"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyContactFormCheckboxSectionInputs = [
  {
    name: "sectionName",
    type: "string",
    defaultValue: "whatIsYourColor",
    required: true,
  },
  {
    name: "sectionTitle",
    type: "string",
    defaultValue: "What is your favorite color?",
    required: true,
  },
  {
    name: "validationErrorMessage",
    type: "string",
    defaultValue: "Choose at least one favorite color:",
    required: true,
  },
  {
    name: "required",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "type",
    type: "string",
    required: true,
    enum: ["multipleChoice", "singleChoice"],
    defaultValue: "multipleChoice",
  },
  {
    name: "titleAs",
    type: "string",
    enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
    defaultValue: "h4",
  },
  {
    name: "checkboxesData",
    type: "list",
    required: true,
    defaultValue: [
      {
        name: "blue",
        label: "My favorite color is blue",
      },
      {
        name: "green",
        label: "My favorite color is green",
      },
      {
        name: "orange",
        label: "My favorite color is orange",
      },
      {
        name: "red",
        label: "My favorite color is red",
      },
      {
        name: "yellow",
        label: "My favorite color is yellow",
      },
    ],
    subFields: [
      {
        name: "name",
        type: "string",
        required: true,
      },
      {
        name: "label",
        type: "string",
        required: true,
      },
    ],
  },
] as const satisfies Inputs;

export const LoyaltyContactFormCheckboxSectionComponent: RegisteredComponent = {
  name: "LoyaltyContactFormCheckboxSection",
  component: dynamic(async () =>
    withValidation(
      loyaltyContactFormCheckboxSectionInputs,
      (await import("./LoyaltyContactFormCheckboxSection")).LoyaltyContactFormCheckboxSection,
      "LoyaltyContactFormCheckboxSection"
    )
  ),
  inputs: loyaltyContactFormCheckboxSectionInputs,
};
